const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const ADMIN_KEY = 'admin';
const AUTH_ROLE_KEY = 'authRole';

export const normalizeToken = (value) => {
  if (!value || value === 'undefined' || value === 'null') {
    return null;
  }

  const unquoted = String(value).replace(/^"(.*)"$/, '$1').trim();
  if (!unquoted) {
    return null;
  }

  return unquoted.replace(/^Bearer\s+/i, '').trim() || null;
};

export function getAccessToken() {
  const rawToken =
    localStorage.getItem(ACCESS_TOKEN_KEY) ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken');

  return normalizeToken(rawToken);
}

export function getRefreshToken() {
  return normalizeToken(localStorage.getItem(REFRESH_TOKEN_KEY));
}

export function getStoredAdmin() {
  const adminData = localStorage.getItem(ADMIN_KEY);
  if (!adminData) {
    return null;
  }

  try {
    return JSON.parse(adminData);
  } catch {
    return null;
  }
}

export function setTokens({ accessToken, refreshToken }) {
  const normalizedAccess = normalizeToken(accessToken);
  if (!normalizedAccess) {
    throw new Error('Missing access token');
  }

  localStorage.setItem(ACCESS_TOKEN_KEY, normalizedAccess);

  const normalizedRefresh = normalizeToken(refreshToken);
  if (normalizedRefresh) {
    localStorage.setItem(REFRESH_TOKEN_KEY, normalizedRefresh);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  return normalizedAccess;
}

export function getStoredAuthRole() {
  return localStorage.getItem(AUTH_ROLE_KEY) || getStoredAdmin()?.role || null;
}

export function setAuthRole(role) {
  if (role) {
    localStorage.setItem(AUTH_ROLE_KEY, role);
  } else {
    localStorage.removeItem(AUTH_ROLE_KEY);
  }
}

export function setAdmin(admin) {
  if (admin) {
    localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
  } else {
    localStorage.removeItem(ADMIN_KEY);
  }
}

export function clearAuthStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
  localStorage.removeItem(AUTH_ROLE_KEY);
  localStorage.removeItem('token');
  localStorage.removeItem('authToken');
}

export function getTokenExpiryMs(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : 0;
  } catch {
    return 0;
  }
}

export function isAccessTokenExpired(token = getAccessToken(), bufferMs = 60_000) {
  const normalized = normalizeToken(token);
  if (!normalized) {
    return true;
  }

  const expiresAt = getTokenExpiryMs(normalized);
  if (!expiresAt) {
    return true;
  }

  return Date.now() >= expiresAt - bufferMs;
}
